import { Instagram as IgIcon, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Eyebrow, MaskLines } from "./Motion";
import { FEED, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../data/content";

export const Instagram = () => (
  <section id="instagram" data-testid="instagram-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
    <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
      <div>
        <Eyebrow>Instagram</Eyebrow>
        <h2 className="mt-6 font-display text-4xl leading-[1.04] sm:text-5xl lg:text-6xl">
          <MaskLines lines={["Daily looks,", <span key="h" className="italic text-[#8A6A3E]">@{INSTAGRAM_HANDLE}</span>]} />
        </h2>
      </div>
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="btn-dark self-start lg:self-auto" data-testid="instagram-follow-btn">
        <IgIcon className="h-4 w-4" /> Follow on Instagram
      </a>
    </div>
    <div className="-mx-5 mt-14 flex min-w-0 snap-x snap-mandatory gap-3 overflow-x-auto px-5 no-scrollbar sm:-mx-10 sm:px-10 lg:mx-0 lg:grid lg:grid-cols-5 lg:overflow-visible lg:px-0">
      {FEED.map((src, i) => (
        <motion.a
          key={src} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid={`instagram-post-${i}`}
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
          className={`group relative aspect-square w-[72vw] shrink-0 snap-start overflow-hidden bg-[#EDE8E1] sm:w-[40vw] lg:w-auto ${i % 2 ? "lg:mt-10" : ""}`}
        >
          <img src={src} alt="Instagram post" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
          <span className="absolute inset-0 flex items-center justify-center bg-[#1A1816]/0 opacity-0 transition-[opacity,background-color] duration-500 group-hover:bg-[#1A1816]/45 group-hover:opacity-100">
            <ArrowUpRight className="h-8 w-8 text-white" />
          </span>
        </motion.a>
      ))}
    </div>
  </section>
);
